import { Button, Drawer, Input } from 'antd';
import React, { useState } from 'react';
import { App } from 'antd';
import { getHttpErrorMessage } from 'utils/http';
import { captureException } from 'utils/errors';

function AddNoteDrawer({ open, onClose, onSubmit }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();

  const handleClose = () => {
    setContent('');
    onClose();
  };

  const handleSubmit = () => {
    if (!content.trim()) return;
    setLoading(true);
    onSubmit({ content: content.trim() })
      .then(() => setContent(''))
      .catch((e) => {
        captureException(e);
        message.error(getHttpErrorMessage(e) || 'Failed to add note');
      })
      .finally(() => setLoading(false));
  };

  return (
    <Drawer
      title="Add Note"
      width={400}
      open={open}
      onClose={handleClose}
      footer={(
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={handleSubmit} disabled={!content.trim()}>
            Save
          </Button>
        </div>
      )}
    >
      <Input.TextArea
        placeholder="Enter note..."
        value={content}
        onChange={(e) => setContent(e.target.value)}
        rows={6}
        autoSize={{ minRows: 6, maxRows: 12 }}
      />
    </Drawer>
  );
}

export default AddNoteDrawer;
